window.addEventListener('load', function() {
  const honeyPotInput = document.querySelector('[data-maiden-name-field]')

  honeyPotInput.addEventListener('input', function() {
    let honeyPotInputValue = honeyPotInput.value

    const formEl = this.closest('.ftn-newsletter__form')
    const formElSubmit = this.closest('.ftn-newsletter__main-input').querySelector('.ftn-newsletter__submit')

    if (honeyPotInputValue.length >= 1) {
      formElSubmit.setAttribute('disabled', 'disabled')
      formEl.addEventListener('submit', function(event) {
        event.preventDefault()
      })
    } else {
      formElSubmit.removeAttribute('disabled', 'disabled')
    }
  })
})
